export default function Timer($element, endsInSeconds, frequency) {
  const frequencyInSeconds = frequency || 1;
  let timer;
  let endMoment;

  this.initiate = () => {
    if ($element.length > 0) {
      timer = null;
      endMoment = this.getCurrentTimestamp() + endsInSeconds;

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.restart();
        } else {
          this.stop();
        }
      }, false);

      this.start();
    }
  };

  this.getCurrentTimestamp = () => Math.round(new Date() / 1000);

  this.restart = () => {
    this.stop();
    this.start();
  };

  this.start = () => {
    timer = setInterval(() => {
      const left = (endMoment - this.getCurrentTimestamp());
      if (left > 0) {
        const hours = Math.floor(left / 3600);
        const minutes = Math.floor((left - hours * 3600) / 60);
        const seconds = parseInt(left - hours * 3600 - minutes * 60, 10);
        $element.text(this.format(hours, minutes, seconds));
      } else {
        $element.hide();
      }
    }, frequencyInSeconds * 1000);
  };

  this.stop = () => {
    clearInterval(timer);
  };

  this.format = (hours, minutes, seconds) => [
    hours >= 10 ? hours : `0${hours}`,
    minutes >= 10 ? minutes : `0${minutes}`,
    seconds >= 10 ? seconds : `0${seconds}`,
  ].join(':');
}
